import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.909 4.615v10.97c0 .837.842 1.345 1.49.89l7.878-5.485c.6-.413.6-1.366 0-1.79L7.399 3.726c-.648-.456-1.49.053-1.49.89",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }